import { InputAdornment, TextField } from '@mui/material';
import React, { memo, useCallback, useMemo } from 'react'
import SearchButton from "./SearchButton";

const SearchField = ({ searchValue, setSearchValue, getSearchResult, tableBorder }) => {
    // console.log("SearchField Rendered",);

    const handleSearchFilter = useCallback((e) => {

        setSearchValue(e.target.value);

    }, [setSearchValue]);

    const handleKeyUp = useCallback((e) => {

        if (e.key === "Enter") {
            getSearchResult();
        }

    }, [getSearchResult]);

    const endAdornment = useMemo(() => (
        <InputAdornment>
            <SearchButton tableBorder={tableBorder} getSearchResult={getSearchResult} />
        </InputAdornment>
    ), [tableBorder, getSearchResult]);

    return (
        <TextField
            type="text"
            variant="outlined"
            fullWidth
            className="searchButton"
            placeholder="Search..."
            label="Search Filter"
            value={searchValue}
            onChange={handleSearchFilter}
            onKeyUp={handleKeyUp}
            InputProps={{
                endAdornment: endAdornment,
            }}
        />
    );
};

export default memo(SearchField);